export enum ImageFormatVariantEnum {
  DEFAULT = 'default',
  RECTANGLE = 'rectangle',
}
